import { config } from '../utils/constants/api.constants';

export default (api) => {
  const getSlotDefinition = (slotType) => {
    const url =
      config.api.slotPlanner.baseUrl +
      `/api/slot/definition?slotType=${slotType}`;
    return new Promise((resolve, reject) => {
      api
        .get(url)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const saveNodeConfig = (slotType, nodeConfig) => {
    const url =
      config.api.slotPlanner.baseUrl + `/api/slot/config/${slotType}/node`;
    return new Promise((resolve, reject) => {
      api
        .put(url, nodeConfig)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getSlotsAvailabilityInfo = (params) => {
    const url = `${config.api.slotPlanner.baseUrl}/api/slot`;
    return new Promise((resolve, reject) => {
      api
        .get(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  return {
    getSlotDefinition,
    saveNodeConfig,
    getSlotsAvailabilityInfo,
  };
};
const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
